import { UseFormRegister, FieldErrors } from "react-hook-form";
import {
  Typography,
  TextField,
  BaseTextFieldProps,
} from "@material-ui/core";
import { sharedUserInfoStyles } from "../Styles/sharedUserInfoStyles";

type TextFieldComponentProps = {
  id: string;
  label: string;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  maxLength?: number;
  fontSize?:number;
} & BaseTextFieldProps;
export const TextFieldComponent = ({
  id,
  label,
  register,
  errors,
  maxLength,
  fontSize,
  ...rest
}: TextFieldComponentProps) => {
  const classes = sharedUserInfoStyles();
  return (
    <>
      <TextField
        label={label}
        inputProps= {{  maxLength: maxLength && maxLength }}
        className={classes.labelPadding}
        fullWidth
        required
        margin="normal"
        variant="standard"
        InputLabelProps={{
          shrink: true,
          color: "primary",
          style: { fontSize: fontSize ? fontSize : "20px" },
        }}
        data-qa={id}
        error={errors[id] ? true : false}
        {...register(id)}
        {...rest}
      />
      <Typography variant="inherit" className={classes.errorLabel}>
        {errors[id]?.message}
      </Typography>
    </>
  );
};
